/* eslint-disable */
(function (jQuery, Drupal, once) {
  'use strict';

  Drupal.behaviors.now_views = {
    attach(context, settings) {
      const $viewProductsByAlpha = jQuery('.view-display-id-products_by_alphabet_block', context);
      const $viewNOWledgeFilters = jQuery('#views-exposed-form-nowledge-nowledge-view-block', context);
      const $viewNOWledge = jQuery('.view-display-id-nowledge_view_block', context);
      const $viewRecipesFilters = jQuery('#views-exposed-form-recipes-recipes-view-block', context);
      const $viewRecipes = jQuery('.view-display-id-recipes_view_block', context);
      const $viewWorkouts = jQuery('.view-display-id-workouts_view_block', context);
      const $viewWorkoutsFilters = jQuery('#views-exposed-form-workouts-with-filters-workouts-view-block', context);

      function filterFormSubmit($form) {
        $form.addClass('before-save');
        $form.find('[data-drupal-selector^="edit-submit"]').click();
      }

      function shareFormState($form) {
        const formData = new FormData($form[0]);
        const data = [...formData.entries()];
        const asString = data
          .filter(x => x[1])
          .map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
          .join('&');
        if (asString) {
          const shareLinkURL = window.location.href.split('?')[0] + '?' + asString;
          let $shareLink = $form.find('.share-link');
          if ($shareLink.length === 0) {
            $shareLink = jQuery('<a class="share-link">Update URL for sharing</a>');
            $form.append($shareLink);
          }
          $shareLink.attr('href', shareLinkURL);
          return true;
        }
        return false;
      }

      function nowViewExposedFilters($form, $view) {
        if (typeof window.scrollTopView === 'undefined') {
          window.scrollTopView = false;
        }

        $form.find('[data-drupal-selector^="edit-submit"]').blur();
        shareFormState($form);

        if (window.scrollTopView) {
          window.scrollTopView = false;
          const t = $view.offset().top - jQuery('.global-header').height();
          jQuery('html, body').animate({ scrollTop: t }, 500);
        }

        let $openFiltersBtn = jQuery('.js-open-filter', context);
        if ($openFiltersBtn.length < 1) {
          $openFiltersBtn = jQuery('<button class="js-open-filter" type="button" aria-label="open filters">Filter</button>');
          $view.find('.view-header').append($openFiltersBtn);
        }
        $openFiltersBtn.off().on('click', function() {
          $form.closest('.block').addClass('show');
        });

        let $closeFiltersBtn = jQuery('.js-close-filter', context);
        if ($closeFiltersBtn.length < 1) {
          $closeFiltersBtn = jQuery('<button class="js-close-filter" type="button" aria-label="close filters">Close Filter</button>');
          $form.prepend($closeFiltersBtn);
        }
        $closeFiltersBtn.off().on('click', function() {
          $form.closest('.block').removeClass('show');
        });

        $form.find('.fieldset-legend').off().on('click', function() {
          const $formItem = jQuery(this).closest('.form-item');
          const itemId = $formItem.attr('data-drupal-selector');
          $formItem.toggleClass('show');
          if ($formItem.hasClass('show')) {
            window.openFilters.push(itemId);
          } else {
            const i = window.openFilters.indexOf(itemId);
            if (i > -1) {
              window.openFilters.splice(i, 1);
            }
          }
          $formItem.removeClass('show-no-transition');
        });

        $form.find('input[type="checkbox"]').on('change', function() {
          window.scrollTopView = true;
          filterFormSubmit($form);
        });

        $form.off('keypress').on('keypress', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            window.scrollTopView = true;
            filterFormSubmit($form);
          }
        });

        $form.find('.fieldgroup').each(function() {
          const $fields = jQuery(this);
          const n = $fields.find('input:checked').length;
          const $legend = $fields.find('.fieldset-legend');
          $legend.find('.active-item-count').remove();
          if (n > 0) {
            $legend.append('<span class="active-item-count">' + n + '<span class="sr-only"> active filters</span></span>');
          }
        });

        if (typeof window.openFilters === 'undefined') {
          window.openFilters = [];
        } else {
          window.openFilters.forEach(function (formItemId) {
            const $item = jQuery(`[data-drupal-selector="${formItemId}"]`);
            $item.addClass('show-no-transition');
            setTimeout(function() {
              $item.addClass('show').removeClass('show-no-transition');
            }, 500);
          });
        }
      }

      function alphaCleanupOrphans($view) {
        $view.find('.view-content > .views-row').each(function() {
          const $row = jQuery(this);
          const letter = $row.text().replace(/\W/g, '')[0];
          if (letter !== undefined) {
            const $group = $view.find('#view-group-' + letter.toLowerCase());
            $group.find('.views-group-content').append($row);
          }
        });
      }

      once('now-views-init', 'body', context).forEach(() => {
        jQuery(document, context).on('click', '.view-header .jump-link', function (event) {
          event.preventDefault();
          jQuery('html, body').animate({
            scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - jQuery('.global-header').height()
          }, 500);
        });

        jQuery(document, context).on('click', '.views-group-content .to-top', function (event) {
          event.preventDefault();
          jQuery('html, body').animate({ scrollTop: 0 }, 500);
        });

        if ($viewProductsByAlpha.length > 0) {
          alphaCleanupOrphans($viewProductsByAlpha);
        }
        if ($viewRecipesFilters.length > 0) {
          nowViewExposedFilters($viewRecipesFilters, $viewRecipes);
        }
        if ($viewWorkoutsFilters.length > 0) {
          nowViewExposedFilters($viewWorkoutsFilters, $viewWorkouts);
        }
        if ($viewNOWledgeFilters.length > 0) {
          nowViewExposedFilters($viewNOWledgeFilters, $viewNOWledge);
        }
      });
    }
  };
})(jQuery, Drupal, once);
